import GainsightProvider from '../../contexts/GainsightProvider';
import { AdskDataServiceProvider } from '../../contexts/AdskDataServiceProvider';
import React from 'react';

export interface AnalyticsProviderProps {
	/**
	 * @deprecated No longer controls mounting. AdskDataServiceProvider
	 * self-gates on the ADSK_ADP_ANALYTICS flag internally (it provides a null
	 * context and runs no analytics when the flag is off, which is observably
	 * identical to it being absent). Retained for backward compatibility.
	 */
	isAdpAnalyticsEnabled?: boolean;
	children: React.ReactElement;
}

/**
 * Renders a structurally-stable provider tree so the subtree below it is never
 * remounted by an analytics flag change.
 *
 * Previously this component swapped its top-level wrapper
 * (AdskDataServiceProvider vs GainsightProvider) based on the
 * ADSK_ADP_ANALYTICS flag. That flag flips false→true the moment LaunchDarkly
 * flags resolve, which changed the element type at this position and forced
 * React to unmount/remount everything below — including LoadingProvider, whose
 * useInitialization hook would then run a second time (firing every init
 * request twice). AdskDataServiceProvider already no-ops when the flag is off,
 * so mounting it unconditionally is behaviour-preserving and removes the
 * remount.
 */
export const AnalyticsProvider = ({
	children,
}: AnalyticsProviderProps): JSX.Element => (
	<AdskDataServiceProvider>
		<GainsightProvider>{children}</GainsightProvider>
	</AdskDataServiceProvider>
);
